import { gql } from "apollo-boost";

export const DRILL_MERGE = gql`
  mutation MutateDrillLib(
    $drillId: Int
    $drillName: String!
    $drillDesc: String
    $drillPurpose: String
    $videoId: String
    $videoUrl: String
    $equipment: String
    $sportType: String!
    $facility: String
    $status: String
    $tag: String
    $level: String
    $userId: Int
    $updateSource: String!
  ) {
    drillMerge(
      drilllibData: {
        drillId: $drillId
        drillName: $drillName
        drillDesc: $drillDesc
        drillPurpose: $drillPurpose
        videoId: $videoId
        videoUrl: $videoUrl
        equipment: $equipment
        sportType: $sportType
        facility: $facility
        status: $status
        tag: $tag
        level: $level
        userId: $userId
        updateSource: $updateSource
      }
    ) {
      node {
        drillId
        drillName
        drillDesc
        drillPurpose
        videoId
        videoUrl
        equipment
        sportType
        facility
        status
        tag
        level
        userId
        updateSource
      }
    }
  }
`;

export const DRILL_DEL = gql`
  mutation drillDelete($drillId: Int!) {
    drillDelete(drillId: $drillId) {
      status
    }
  }
`;

export const FAVORITE_DRILL_LIB_MERGE = gql`
  mutation favoriteDrillMerge($favdrillId: Int, $userId: Int!, $drillId: Int) {
    favoriteDrillMerge(
      favoriteDrilllibData: {
        favdrillId: $favdrillId
        userId: $userId
        drillId: $drillId
      }
    ) {
      node {
        id
        favdrillId
        userId
        drillId
      }
    }
  }
`;
